export default function ({ categoryUrl = '', hasParent = false }) {
    return {
        categoryUrl,
        hasParent,
        isSelected: false,
        init() {
            this.setSelected();

            if (this.isSelected && this.hasParent) {
                // open parent collapsible component
                this.open();
                // select parent category
                this.setParentSelected();
            }
        },
        setSelected() {
            const { origin, pathname } = window.location;
            this.isSelected = origin + pathname === categoryUrl;
        },
        setParentSelected() {
            const parentCategoryComponent = this.$el
                .closest('.level-0')
                .querySelector('[x-data]');

            parentCategoryComponent._x_dataStack.some((el) => {
                if (el.isSelected === false) {
                    el.isSelected = true;
                    return true;
                }
            });
        }
    };
}
